import Http from "../engine/Http";
import { AuditableNamedIdentifiable, Dimension, Identifiable, ItemCompletedOrderRecord } from "../model/Items";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

interface Price {
  effective: number;
}

export interface Form
extends AuditableNamedIdentifiable {
  dimension: Dimension;
  price: Price;
  material: Identifiable;
  weight: number;
}

export interface CompletedOrderForm
extends ItemCompletedOrderRecord {
  formId: number;
}

const useFormApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchForms = (customerId: number, priceListId: number) : Promise<Form[]> =>
    Http.get(`/api/customers/${customerId}/price-lists/${priceListId}/forms`, [ authenticationHeader ]);

  const fetchForm = (customerId: number, priceListId: number, formId: number) : Promise<Form> =>
    Http.get(`/api/customers/${customerId}/price-lists/${priceListId}/forms/${formId}`, [ authenticationHeader ]);

  const deleteForm = (customerId: number, priceListId: number, formId: number) =>
    Http.delete(`/api/customers/${customerId}/price-lists/${priceListId}/forms/${formId}`, [ authenticationHeader ]);

  const fetchCompletedOrderForms = (customerId: number): Promise<CompletedOrderForm[]> =>
    Http.get(`/api/customers/${customerId}/formcompletedorders`, [ authenticationHeader ]);

  return {
    fetchForms,
    fetchForm,
    fetchCompletedOrderForms,
    deleteForm
  }
}

export default useFormApi;